import { Component, Input, OnInit } from '@angular/core';
import { OrderType } from 'src/app/api/contracts/order';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-order-type-switch-warning',
  templateUrl: './order-type-switch-warning.component.html',
  styleUrls: ['./order-type-switch-warning.component.scss'],
})
export class OrderTypeSwitchWarningComponent implements OnInit {
  @Input() itemsQuantity!: number;
  @Input() desiredType!: OrderType;

  constructor(public readonly modalService: ModalService) {}

  ngOnInit() {
    return;
  }
}
